import React, { useState } from 'react';
import moment from 'moment';
import calendarIcon from '../../assets/images/calendar.svg';
import Loading from '~/components/layout/Loading';

import {
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  CloseButton,
  ModalTitle,
  CalendarIcon,
  ModalContent,
  ModalMessage,
  ButtonContainer,
  NoButton,
  YesButton
} from './styles';

const VisitConfirmationModal = ({
  isOpen,
  onClose,
  consultantName,
  visitDate,
  visitTime,
  onImmediateConfirm,
  onDeny,
}) => {

  if (!isOpen) return null;

  const dateSource = visitDate || visitTime;
  const formattedDate = dateSource ? moment(dateSource).format('DD/MM/YYYY') : '';

  const handleConfirm = () => {
    if (onImmediateConfirm) {
      try {
        const body = {
          confirm: 'true',
          user_id: localStorage.getItem('userId'),
        };
        onImmediateConfirm(body);
      } catch (e) {
        console.warn('onImmediateConfirm error', e);
      }
    }
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDeny = async () => {
    if (!onDeny) return;
    setIsSubmitting(true);
    try {
      const body = {
        confirm: 'false',
        finished: 'true',
        user_id: localStorage.getItem('userId'),
      };
      const result = onDeny(body);
      if (result && typeof result.then === 'function') {
        await result;
      }
    } catch (e) {
      console.warn('onDeny error', e);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalOverlay>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <CalendarIcon>
            <img src={calendarIcon} alt="Calendário" />
          </CalendarIcon>
          <CloseButton onClick={onClose}>×</CloseButton>
        </ModalHeader>

        <ModalTitle>Confirmação de visita</ModalTitle>

        <ModalContent>
          <ModalMessage>
            Olá parceiro, o consultor <strong>{consultantName}</strong> esteve
            presente em sua revenda no dia <strong>{formattedDate}</strong>?
          </ModalMessage>

          <ButtonContainer>
            <NoButton onClick={handleDeny}>
              Não
            </NoButton>
            <YesButton onClick={handleConfirm}>
              Sim
            </YesButton>
          </ButtonContainer>
        </ModalContent>
      </ModalContainer>
      {isSubmitting && (
        <div aria-hidden style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }}>
          <Loading />
        </div>
      )}
    </ModalOverlay>
  );
};

export default VisitConfirmationModal;
